export const LOGIN_THEME_EVENT_ID_STORAGE_KEY = 'loginThemeEventId';
const PERSISTENT_STORAGE_KEYS = [LOGIN_THEME_EVENT_ID_STORAGE_KEY];
// Сохранение данных в Local Storage
export function setLocalStorageItem(key, value) {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
        return true;
    }
    catch (error) {
        console.error('Error saving to Local Storage:', error);
        return false;
    }
}
// Получение данных из Local Storage
export function getLocalStorageItem(key) {
    try {
        const serializedValue = localStorage.getItem(key);
        return serializedValue ? JSON.parse(serializedValue) : null;
    }
    catch (error) {
        console.error('Error retrieving from Local Storage:', error);
        return null;
    }
}
// Удаление данных из Local Storage
export function removeLocalStorageItem(key) {
    try {
        localStorage.removeItem(key);
        return true;
    }
    catch (error) {
        console.error('Error removing from Local Storage:', error);
        return false;
    }
}
// Очистка всего Local Storage
export function clearLocalStorage() {
    try {
        const persistentItems = PERSISTENT_STORAGE_KEYS.map((key) => [
            key,
            localStorage.getItem(key)
        ]);
        localStorage.clear();
        persistentItems.forEach(([key, value]) => {
            if (value !== null) {
                localStorage.setItem(key, value);
            }
        });
        return true;
    }
    catch (error) {
        console.error('Error clearing Local Storage:', error);
        return false;
    }
}
export function setToken(value, expiration) {
    const item = {
        value: value,
        expiry: expiration
    };
    localStorage.setItem('token', JSON.stringify(item));
}
export function getToken() {
    const item = getLocalStorageItem('token');
    if (!item) {
        return null;
    }
    const now = new Date();
    const expiry = new Date(item.expiry);
    if (now.getTime() > expiry.getTime()) {
        clearLocalStorage();
        return null;
    }
    return item.value;
}
